// src/pages/Industry.js
import React from 'react';
import { NavLink } from 'react-router-dom';

const IndustryBreadcrumb = () => (
  <div
    className="optech-breadcrumb"
    style={{ backgroundImage: 'url(/assets/images/breadcrumb/breadcrumb.png)' }}
  >
    <div className="container">
      <h1 className="post__title">Industries We Work With</h1>
      <nav className="breadcrumbs">
        <ul>
          <li><NavLink to="/services">AI Service</NavLink></li>
          <li aria-current="page">Industries We Work With</li>
        </ul>
      </nav>
      <p className="text-white pt-5">
        Numerous sectors increasingly depend on specialized language and AI services to remain
        competitive in local and international settings. R A Inc has supported a diverse array of
        clients, from public institutions to tech start-ups, customizing our expertise for each
        field’s demands.
      </p>
    </div>
  </div>
);

const IndustryContent = () => (
  <div className="section optech-section-padding">
    <div className="container">
      <div className="row">
        {/* Main content */}
        <div className="col-lg-8">
          <div className="optech-service-details-wrap">
            <img
              data-aos="fade-up"
              data-aos-duration="800"
              src="/assets/images/service/industries.jpg"
              alt="Industries Service"
              className="mb-5"
            />

            {/* Overview */}
            <div className="optech-service-details-item">
              <h3>Overview</h3>
              <p>
                Every industry has its own unique vocabulary, regulations, and standards that must be
                recognized when creating content or deploying AI solutions. For instance, a legal
                document translation requires a high level of precision, while marketing campaigns
                may need culturally tuned messaging to connect with consumers. We delve into these
                details to ensure the final outputs are both contextually correct and easy to
                comprehend.
              </p>
            </div>

            {/* Key Sectors */}
            <div className="optech-service-details-item">
              <h3>Key Sectors</h3>
              <ul className="list-unstyled">
                {[
                  'Technology: Software user interface localization, hardware documentation updates.',
                  'eCommerce: Product descriptions, localized sales funnels, global marketing materials.',
                  'Software & Hardware: Guides, troubleshooting manuals, developer documentation.',
                  'Marketing & Customer Support: Brand messaging, chatbot design, multilingual customer engagement.',
                  'Legal & Government: Policy translations, official gazettes, and litigation materials.',
                  'Medical & Pharma: Clinical study translations, patient instructions, drug labeling.',
                  'eLearning & Media: Curriculum localization, research publications, entertainment subtitles.',
                  'Banking & Finance: Annual reports, loan agreements, and financial advisories.'
                ].map((item, i) => (
                  <li key={i}><i className="ri-check-line"></i> {item}</li>
                ))}
              </ul>
            </div>

            {/* Industry Examples Table */}
            <div className="optech-service-details-item">
              <h3>Industry Examples</h3>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Industry</th>
                    <th>Typical Project</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Healthcare</td>
                    <td>Translating patient forms, medical device instructions</td>
                  </tr>
                  <tr>
                    <td>Financial</td>
                    <td>Adapting compliance documents, risk assessment materials</td>
                  </tr>
                  <tr>
                    <td>Education</td>
                    <td>Multimedia study packs, scholarly article proofreading</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Highlights */}
            <div className="optech-service-details-item">
              <h3>Highlights</h3>
              <ul className="list-unstyled">
                {[
                  'We maintain specialized glossaries to keep terminology consistent across your materials.',
                  'Teams often receive field-specific training, ensuring familiarity with subject matter jargon.',
                  'Our capacity scales for high-volume projects, meeting tight deadlines and quality benchmarks.'
                ].map((item, i) => (
                  <li key={i}><i className="ri-check-line"></i> {item}</li>
                ))}
              </ul>
            </div>

            {/* Conclusion */}
            <div className="optech-service-details-item">
              <h3>Conclusion</h3>
              <p>
                Each industry operates under distinctive conventions and linguistic demands. R A Inc
                takes a thorough approach, recognizing and integrating these sector-specific
                nuances. Whether you’re rolling out a platform internationally or preparing legal
                disclosures for multiple jurisdictions, we provide an integrated blend of language
                expertise and AI functionality, helping you thrive in any environment.
              </p>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="col-lg-4">
          <div className="optech-service-sidebar">

            {/* Service Menu */}
            <div className="optech-service-menu">
               <ul>
                                <li>
                                  <NavLink to="/multimedia-and-dtp-services">
                                  Multimedia & DTP Services <i className="ri-arrow-right-up-line" />
                                  </NavLink>
                                </li>
                                <li>
                                  <NavLink to="/audio-and-video-transcription">
                                  Audio & Video Transcription <i className="ri-arrow-right-up-line" />
                                  </NavLink>
                                </li>
                                <li>
                                  <NavLink to="/subtitling">
                                  Subtitling <i className="ri-arrow-right-up-line" />
                                  </NavLink>
                                </li>
                                <li>
                                  <NavLink to="/desktop-publishing-services">
                                  Desktop Publishing Services <i className="ri-arrow-right-up-line" />
                                  </NavLink>
                                </li>
                                <li>
                                  <NavLink to="/multilingual-desktop-publishing">
                                  Multilingual Desktop Publishing <i className="ri-arrow-right-up-line" />
                                  </NavLink>
                                </li>
                                <li>
                                  <NavLink to="/multimedia-and-dtp-tools">
                                  Multimedia & DTP Tools <i className="ri-arrow-right-up-line" />
                                  </NavLink>
                                </li>
                              </ul>
            </div>

            {/* Sidebar CTA */}
            <div
              className="optech-service-contact"
              data-aos="fade-up"
              data-aos-duration="800"
              style={{ backgroundImage: 'url(/assets/images/service/bg.png)' }}
            >
              <div className="optech-service-contact-icon">
                <img src="/assets/images/service/icon.svg" alt="Get in Touch" />
              </div>
              <h3>Industries We Work With</h3>
              <p>
                We tailor our language and AI solutions to meet the unique standards, terminology,
                and compliance needs of diverse sectors—ensuring industry-specific accuracy and
                impact.
              </p>
              <NavLink className="optech-default-btn" data-text="Get in Touch" to="/contact-us">
                <span className="btn-wraper">Get in Touch</span>
              </NavLink>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
);

const IndustryCTA = () => (
  <div
    className="section bg-cover optech-section-padding"
    style={{ backgroundImage: 'url(/assets/images/cta/cta-bg2.png)' }}
  >
    <div className="container">
      <div className="optech-cta-wrap">
        <div className="optech-cta-content center">
          <h2>Let's Translate Your Vision Into Every Language</h2>
          <p>
            Whether you're expanding your business internationally or need multilingual content for
            local markets, we provide solutions tailored to your goals, audience, and tone.
          </p>
          <div className="optech-extra-mt" data-aos="fade-up" data-aos-duration="800">
            <NavLink className="optech-default-btn" data-text="Let’s Start a Project" to="/contact-us">
              <span className="btn-wraper">Let’s Start a Project</span>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const Industry = () => (
  <>
    <IndustryBreadcrumb />
    <IndustryContent />
    <IndustryCTA />
  </>
);

export default Industry;